// extracted by mini-css-extract-plugin
export default {"container":"audio-wave_container__tSNDY","waveContainer":"audio-wave_waveContainer__9WKbg","bar":"audio-wave_bar__yfHQD","barInactive":"audio-wave_barInactive__kxCiz"};